var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-col",class:[_vm.spanClass, _vm.offSetClass, _vm.xsClass, _vm.smClass, _vm.mdClass, _vm.lgClass, _vm.xlClass],style:(_vm.colStyle)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }